import loadable from '@loadable/component'

export default [
  {
    // 歌房PK弹窗
    path: '/code/SongRoomPk',
    exact: true,
    component: loadable(
      () =>
        import(
          /* webpackChunkName: "page-code-SongRoomPk" */ '~/pages/r_code/SongRoomPk'
        )
    ),
  },
]
